import assetRoutesModule from './assetRoutesModule';
export default function assetRoutesExtension(_ref) {
  var refreshInterval = _ref.refreshInterval,
      assetContainerRewriteMap = _ref.assetContainerRewriteMap;
  return {
    id: 'assetRoutes',
    redux: {
      modules: [assetRoutesModule]
    },
    server: process.browser ? {} : {
      configure: function configure(server) {
        var _require = require('./assetRoutesMiddleware'),
            assetRoutesMiddleware = _require["default"];

        server.useTracked('assetRoutesMiddleware', assetRoutesMiddleware({
          refreshInterval: refreshInterval,
          assetContainerRewriteMap: assetContainerRewriteMap
        }));
      },
      handler: function handler(_ref2) {
        var handler = _ref2.handler,
            app = _ref2.app,
            server = _ref2.server;

        var assetRoutesHandler = require('./assetRoutesHandler')["default"];

        return assetRoutesHandler({
          handler: handler,
          app: app,
          server: server
        });
      }
    }
  };
}